import { Col, Label,ReactSelectBox } from "client/CommonComponents";

const StandarizedEquipment = (props?: any) => {
  const managedEquipmentValues = props?.managedEquipmentValues;
  const categoryDropdownList = props?.categoryDropdownList;
  const manufacturerDropDownList = props?.manufacturerDropDownList;
  const managedEquipRef = props?.managedEquipRef;
  const handleCategoryChange = props?.handleCategoryChange;
  const handleManufacturerChange = props?.handleManufacturerChange;

  return (<>
      <Col xs={12} sm={4} md={4} lg={4} className='mt-2 mt-sm-0 mb-md-0 mb-2'>
        <Label data-attribute="StandarizedEquipment_Default_Label">Category</Label>
        <ReactSelectBox
          options={categoryDropdownList}
          onChange={(item: any, e: any) => handleCategoryChange(e, item,'category')}
          value={managedEquipmentValues?.category}
          selectRef={(element:any)=> managedEquipRef.current[1] = element}
         data-attribute="StandarizedEquipment_Default_SearchSelectBox" />
      </Col>
      <Col xs={12} sm={4} md={4} lg={4} className='mt-2 mt-sm-0 mb-sm-0 mb-3'>
        <Label data-attribute="StandarizedEquipment_Default_Label_2">Manufacturer</Label>
        <ReactSelectBox
          options={manufacturerDropDownList}
          onChange={(item: any, e: any) => handleManufacturerChange(e, item,'manufacturer')}
          value={managedEquipmentValues?.manufacturer}
          selectRef={(element:any)=> managedEquipRef.current[2] = element}
          isSearchable={true}
         data-attribute="StandarizedEquipment_Default_SearchSelectBox_2" />
      </Col>    
  </>)
}

export default StandarizedEquipment;
